import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import {unpackId} from 'common/diplomatIdUtil';
import {useDispatch} from 'react-redux';
import {layoutActions} from 'features/layout/redux';
import MoveDialog from 'features/layout/DialogRoutes/dialogs/MoveDialog';

interface MoveFolderDialogProps {
   data: INav;
   header: string;
   onClose: () => void;
}
const MoveFolderDialog = ({data, header, onClose}: MoveFolderDialogProps) => {
   const dispatch = useDispatch();
   const {id: folderId} = unpackId(data.id);
   const {request: move} = usePostApi(api.folderMove, {
      onSuccess: () => {
         dispatch(layoutActions.loadTreeNav());
         onClose();
      },
      onFailure: onClose,
   });
   const handleMove = (parentFolderId: string) => {
      move(
         JSON.stringify({
            folderId,
            parentFolderId,
         })
      );
   };

   return <MoveDialog data={data} header={header} onConfirm={handleMove} onClose={onClose} />;
};

export default MoveFolderDialog;
